/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/SaveAction",
  isSubmitting
  
}) {
let stepsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'steps',
})
let stepsStepsLengthValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'steps.length',
})
let stepsCurrentIndexValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'current_index',
})
let aggregateData = fromHelpers.isLastStep(stepsStepsLengthValueData, stepsCurrentIndexValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 marginLeft={dtSpaceXs}
 onClick={onClick}
 data="steps"
 disabled={stepsIsSubmittingData}
 text={aggregateData ? "Save" : "Next"}
 data="steps.steps.length"
 data="steps.current_index"
 aggregate="helpers.js isLastStep"
/>
{children}
</React.Fragment>)
}